package uz.ferro.erp.feature.product.data

import uz.ferro.erp.api.suspendGet
import uz.ferro.erp.feature.product.model.CountryProducts
import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.feature.product.model.RegionProducts

object ProductManager {

    suspend fun getRegionProducts(id: Long): RegionProducts {
        return suspendGet("product/list/region/${id}")
    }

    suspend fun getCountryProducts(id: Long): CountryProducts {
        return suspendGet("product/list/country/${id}")
    }

    suspend fun getProduct(id: Long): Product{
        return suspendGet("product/$id")
    }

    suspend fun getActiveProducts(): List<Product> {
        return suspendGet("product/list")
    }

    suspend fun getAllProducts(): List<Product> {
        return suspendGet("admin/product/list")
    }

    suspend fun getTopupProducts(orderId: Long): List<Product> {
        return suspendGet("product/order-top-up-products/${orderId}")
    }

}